import React, { useState } from 'react';
import './Mapa.scss';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import MapBox from '../MapBox/MapBox';
import { useTranslation } from 'react-i18next';

const Mapa = (props) => {
  const { t } = useTranslation();

  const destinations = {
    ORIGEN: {
      lat: 20.509106231909826,
      lng: -100.40774736222625
    }
  };
  let [selectdestination, setDestination] = useState(null);

  return (
    <div id="ubicacion" className='contenedor_mapa'>
      <div className='mapa'>
        <MapBox/>
      </div>
      <div className='ubicaciones'>
        <div className='top'>
          <AnimationOnScroll
            duration={2}
            animateOnce={true}
            animateIn='animate__fadeIn'>
            <div className='top_subtitulo'>
              <h2>{t('mapa.nearbyTitle')}</h2>
            </div>
          </AnimationOnScroll>
          <div className='top_texto'>
            <p>{t('mapa.address')}</p>
          </div>
        </div>
        <div className='bottom'>
          <div className='bottom_ubicaciones'>
            <div className='row_list'>
              <img src="/assets/favicon/apple-icon-57x57.png" alt="" />
              <p>{t('mapa.closeTo.studyCenters')}</p>
            </div>
            <div className='row_list'>
              <img src="/assets/favicon/apple-icon-57x57.png" alt="" />
              <p>{t('mapa.closeTo.surponiente')}</p>
            </div>
            <div className='row_list'>
              <img src="/assets/favicon/apple-icon-57x57.png" alt="" />
              <p>{t('mapa.closeTo.constituyentes')}</p>
            </div>
            <div className='row_list'>
              <img src="/assets/favicon/apple-icon-57x57.png" alt="" />
              <p>{t('mapa.closeTo.commercialCenters')}</p>
            </div>
            <div className='row_list'>
              <img src="/assets/favicon/apple-icon-57x57.png" alt="" />
              <p>{t('mapa.closeTo.santiago')}</p>
            </div>
          </div>
          <div className='mapas'>
            <a target={'_blank'} href="https://goo.gl/maps/9yMnUXV9ENvEhrqg7"><img src="/assets/Logos/svg-icon-maps.svg" alt="Google Maps" /></a>
            <a target={'_blank'} href="https://www.waze.com/en/live-map/directions/mx/qro./corregidora/velasur?place=ChIJMS96ivdF04URmNPxYOsTYGY&utm_campaign=waze_website&utm_medium=website_menu&utm_source=waze_website"><img src="/assets/Logos/svg-icon-waze.svg" alt="Waze" /></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mapa;
